import { render, staticRenderFns } from "./AbrFormPage.vue?vue&type=template&id=c68952bc"
import script from "./AbrFormPage.vue?vue&type=script&lang=js"
export * from "./AbrFormPage.vue?vue&type=script&lang=js"
import style0 from "./AbrFormPage.vue?vue&type=style&index=0&id=c68952bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports